import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface DetailsTableStylesProps {
  smallMedia: boolean
}

const useStyles = makeStyles<Theme, DetailsTableStylesProps>(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    overflowY: 'hidden',
    background: 'white',
    borderBottomRightRadius: '15px'
  },

  section: {
    display: 'flex',
    borderBottom: '1px solid rgba(230, 234, 236, 0.9)',
    boxSizing: 'border-box',

    '& > :first-child': {
      margin: '0 5%',
      width: '90%',
      padding: ({ smallMedia }) => (smallMedia ? '1.5rem 0' : '1rem 0'),
      overflow: 'hidden'
    }
  },

  paddedSection: {
    padding: '1rem 0'
  },

  container: {
    overflow: 'hidden',
    width: '100%',

    '&:hover': {
      overflowY: 'overlay',

      '&::-webkit-scrollbar-track': {
        backgroundColor: '#f1f1f1'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#0000001e'
      },
      scrollbarWidth: 'auto',
      scrollbarColor: '#0000001e #f1f1f1'
    },

    '& > :last-child': {
      paddingBottom: '1rem',
      borderBottom: 'none',
      flexWrap: 'wrap'
    }
  }
}))

export default useStyles
